import type { FC } from "react";
import ProgressBar from "../../../../../../components/progress-bar/progress-bar";
import * as CSS from "./poll-option.styles";

type PollOptionProps = {
	option: string;
	votes: number;
	totalVotes: number;
};

const PollOption: FC<PollOptionProps> = ({ option, votes, totalVotes }) => {
	const percentage =
		totalVotes > 0 ? Math.round((votes / totalVotes) * 100) : 0;

	return (
		<CSS.PollOption>
			<CSS.PollLabelRow>
				<span>{option}</span>
				<span>
					{votes} {votes === 1 ? "vote" : "votes"} ({percentage}%)
				</span>
			</CSS.PollLabelRow>
			<ProgressBar percentage={percentage} />
		</CSS.PollOption>
	);
};

export default PollOption;
